import request from '@/utils/request'

/** 我的待办列表 */
export function getMyTodoList(data) {
  return request({
    url: '/api/Extend/LqTodo/MyTodoList',
    method: 'get',
    data
  })
}

/** 待办数量统计 */
export function getTodoCount() {
  return request({
    url: '/api/Extend/LqTodo/TodoCount',
    method: 'get'
  })
}

/** 创建待办（自定义） */
export function createTodo(data) {
  return request({
    url: '/api/Extend/LqTodo',
    method: 'post',
    data
  })
}

/** 标记待办已完成 */
export function handleTodo(id) {
  return request({
    url: `/api/Extend/LqTodo/Handle/${id}`,
    method: 'post'
  })
}

/** 忽略待办 */
export function dismissTodo(id) {
  return request({
    url: `/api/Extend/LqTodo/Dismiss/${id}`,
    method: 'post'
  })
}
